import React from "react";
import { MdOutlineContactEmergency } from "react-icons/md";
import { MdOutlineReceiptLong } from "react-icons/md";
import { MdOutlineAccountBalance } from "react-icons/md";

export const KycInfo = () => {
  return (
    <div className="kycInfo_container">
      <h6 className="kyc_info_heading">
        Keep your documents ready for KYC! ✅
      </h6>
      <p>
        Please ensure you have these documents ready for a smooth KYC journey
      </p>
      <div className="summary_kyc_container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MdOutlineContactEmergency size={24} style={{ margin: "1rem" }} />
          <strong>1. PAN Details:</strong>
          <p style={{ paddingLeft: "1rem" }}>
            - PAN Number, Date of Birth, Email Address
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <MdOutlineReceiptLong size={24} style={{ margin: "1rem" }} />
          <strong>2. Billing Address (Current):</strong>
          <p style={{ paddingLeft: "1rem" }}>
            {" "}
            - Complete Address, City, State, Pin code
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <MdOutlineAccountBalance size={24} style={{ margin: "1rem" }} />
          <strong>3. Bank Account Details:</strong>
          <p style={{ paddingLeft: "1rem" }}>
            {" "}
            - Name & Bank Account Number, IFSC Code
          </p>
        </div>
      </div>
    </div>
  );
};
